import React from "react";
import { getSearchStatusBadge } from "../../utils/searchStatusUtils";

const DashboardStatusBadge = ({ status }) => {
    const badge = getSearchStatusBadge(status);

    if (!badge.label) {
        return null;
    }

    return (
        <span
            className={`inline-flex w-fit shrink-0 items-center whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold ${badge.className}`}
        >
            {badge.label}
        </span>
    );
};

export default DashboardStatusBadge;
